import { Position, OverlayToaster, Toaster } from "@blueprintjs/core";

let toaster: Toaster | null = null;
let toasterPromise: Promise<Toaster> | null = null;
let toastKey = 0;

const nextToastKey = (): string => {
  const key = `app-toaster-${toastKey}`;
  toastKey += 1;
  return key;
};

const getToasterPromise = (): Promise<Toaster> => {
  if (toasterPromise === null) {
    toasterPromise = OverlayToaster.create({
      className: "global-toaster",
      position: Position.TOP,
    }).then((instance) => {
      toaster = instance;
      return instance;
    });
  }

  return toasterPromise;
};

const proxyToaster: Toaster = {
  show(props, key) {
    const toastId = key ?? nextToastKey();
    void getToasterPromise().then((instance) => {
      instance.show(props, toastId);
    });
    return toastId;
  },
  dismiss(key) {
    void getToasterPromise().then((instance) => {
      instance.dismiss(key);
    });
  },
  clear() {
    void getToasterPromise().then((instance) => {
      instance.clear();
    });
  },
  getToasts() {
    return toaster?.getToasts() ?? [];
  },
};

export const AppToaster = function (): Toaster {
  if (toaster !== null) {
    return toaster;
  }

  return proxyToaster;
};
